<template>
    <div class="container">
        <div v-if="isIos" class="ios-content">
            <div class="top">
                <img src="@/assets/common/logo.png" class="logo" />
                <div class="title-wrapper">
                    <div class="title">绿地畅聊</div>
                    <div class="download-desc">如果您的设备已经安装，请先删除；安装后点击去信任(IOS18+需要重启手机)</div>
                    <div class="btn-group">
                        <div class="btn">
                            <img src="@/assets/common/download.png" />
                            <span>安装</span>
                        </div>
                        <div class="btn btn-primary">
                            <img src="@/assets/common/safe.png" />
                            <span>去信任</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider" />
            <div class="app-desc">
                <div class="app-desc-item">
                    <div class="label">232万个评分</div>
                    <div class="amount">4.9</div>
                    <div class="bottom">
                        <img src="@/assets/common/star.png" />
                        <img src="@/assets/common/star.png" />
                        <img src="@/assets/common/star.png" />
                        <img src="@/assets/common/star.png" />
                        <img src="@/assets/common/star.png" />
                    </div>
                </div>
                <div class="border" />
                <div class="app-desc-item">
                    <div class="label">排行</div>
                    <div class="amount">#1</div>
                    <div class="bottom">
                        社交/通讯
                    </div>
                </div>
                <div class="border" />
                <div class="app-desc-item">
                    <div class="label">大小</div>
                    <div class="amount">40.5</div>
                    <div class="bottom">
                        兆(MB)
                    </div>
                </div>
                <div class="border" />
                <div class="app-desc-item">
                    <div class="label">年龄</div>
                    <div class="amount">18+</div>
                    <div class="bottom">
                        岁
                    </div>
                </div>
            </div>
            <div class="divider" />
            <div class="introduce">
                <div class="title">简介</div>
                <div class="introduce-content">
                    <div class="content-title">连接全球1亿以上用户</div>
                    <div>
                        绿地畅聊不只是一款优秀的通讯及社交应用软件，更是全球1亿用户都离不开的生活方式。通过绿地畅聊，你不仅能用文字讯息、语音、影片、贴图等多种方式与你的朋友互动，还能连接全球1亿用户，让你的生活更加便捷。
                    </div>
                </div>
            </div>
            <div class="divider" />
            <div class="comment">
                <div class="title">评分及评论</div>
                <div class="comment-content">
                    <div class="comment-left">
                        <div class="score">4.9</div>
                        <div class="score-desc">满分5分</div>
                    </div>
                    <div class="comment-right">
                        <div class="comment-item">
                            <div class="comment-item-left">
                                <img src="@/assets/common/star.png" />
                                <img src="@/assets/common/star.png" />
                                <img src="@/assets/common/star.png" />
                                <img src="@/assets/common/star.png" />
                                <img src="@/assets/common/star.png" />
                            </div>
                            <div class="comment-item-right">
                                <div class="progress" style="width: 95%;" />
                            </div>
                        </div>
                        <div class="comment-item">
                            <div class="comment-item-left">
                                <img src="@/assets/common/star.png" />
                                <img src="@/assets/common/star.png" />
                                <img src="@/assets/common/star.png" />
                                <img src="@/assets/common/star.png" />
                            </div>
                            <div class="comment-item-right">
                                <div class="progress" style="width: 10%;" />
                            </div>
                        </div>
                        <div class="comment-item">
                            <div class="comment-item-left">
                                <img src="@/assets/common/star.png" />
                                <img src="@/assets/common/star.png" />
                                <img src="@/assets/common/star.png" />
                            </div>
                            <div class="comment-item-right">
                                <div class="progress" style="width: 8%;" />
                            </div>
                        </div>
                        <div class="comment-item">
                            <div class="comment-item-left">
                                <img src="@/assets/common/star.png" />
                                <img src="@/assets/common/star.png" />
                            </div>
                            <div class="comment-item-right">
                                <div class="progress" style="width: 5%;" />
                            </div>
                        </div>
                        <div class="comment-item">
                            <div class="comment-item-left">
                                <img src="@/assets/common/star.png" />
                            </div>
                            <div class="comment-item-right">
                                <div class="progress" style="width: 2%;" />
                            </div>
                        </div>
                        <div class="store-item">232万个评分</div>
                    </div>
                </div>
                <div class="comment-wordWrapper">
                    <div class="comment-w-title">
                        <div class="cwt-left">
                            <div class="mb">非常不错的应用，值得推荐！</div>
                            <div class="star-light">
                                <img src="@/assets/common/star-light.png" />
                                <img src="@/assets/common/star-light.png" />
                                <img src="@/assets/common/star-light.png" />
                                <img src="@/assets/common/star-light.png" />
                                <img src="@/assets/common/star-light.png" />
                            </div>
                        </div>
                        <div class="cwt-right">
                            <div class="mb">05-23</div>
                            <div>Anthony Davis</div>
                        </div>
                    </div>
                    <div class="comment-word">
                        这个app的界面设计非常简洁和现代，很容易上手。功能也很齐全，包括聊天、分享、发现新朋友等。特别喜欢的是它的推送通知功能，能够及时提醒我有新的消息和活动。安全性非常好，能够保护用户的隐私和数据。特别喜欢的是它的双重验证功能，能够增加安全性。
                    </div>
                </div>
            </div>
            <div class="divider" />
            <div class="title">资料</div>
            <div class="info-wrapper">
                <div class="info-list">
                    <div class="info-left">供应商</div>
                    <div class="info-right">绿地畅聊technology Co.Ltd</div>
                </div>
                <div class="info-list">
                    <div class="info-left">大小</div>
                    <div class="info-right">40.6MB</div>
                </div>
                <div class="info-list">
                    <div class="info-left">兼容性</div>
                    <div class="info-right">iOS 9.0或以上版本</div>
                </div>
                <div class="info-list">
                    <div class="info-left">语言</div>
                    <div class="info-right">简体中文</div>
                </div>
                <div class="info-list">
                    <div class="info-left">年龄</div>
                    <div class="info-right">18+岁</div>
                </div>
                <div class="info-list">
                    <div class="info-left">App内购买</div>
                    <div class="info-right">是</div>
                </div>
                <div class="info-list">
                    <div class="info-left">版权</div>
                    <div class="info-right">@2025 Sannong Inc.</div>
                </div>
            </div>
            <div class="sheMing">
                <div class="sheMing-title">免责声明</div>
                <div class="sheMing-content">
                    本网站的所有内容仅供参考，不构成任何形式的建议或保证。我们不对因使用或依赖本网站的内容而造成的任何损失或损害负责。
                    我们保留随时更新或修改本免责声明的权利。请定期查看本页面，以确保您了解最新的免责声明。
                </div>
            </div>
        </div>
        <div v-else class="android-content content">
            <div class="top">
                <div class="logo-wrapper">
                    <img src="@/assets/common/logo.png" class="logo" />
                    <div class="logo-text">官方</div>
                </div>
                <div class="title">绿地畅聊</div>
                <div class="download-desc">5.0分&nbsp;|&nbsp;1132万次下载&nbsp;|&nbsp;40MB</div>
                <a class="download-btn" :href="url">安全下载</a>
                <div class="yyb-desc">(腾讯应用宝下载，人工审核保障安全)</div>
                <div class="yyb-safe">
                    <div class="yyb-item">
                        <img src="@/assets/common/safe.png" class="yyb" />
                        <span>无病毒</span>
                    </div>
                    <div class="yyb-item">
                        <img src="@/assets/common/ad.png" class="yyb" />
                        <span>无广告</span>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="label">运营方: 绿地畅聊</div>
                <div class="label">主办单位: 绿地畅聊</div>
                <div class="label">版本号: 1.9.5</div>
                <div class="primary">绿地畅聊&nbsp;|&nbsp;官方认证</div>
                <img src="@/assets/common/yingyb.png" class="yingyb" />
                <div class="desc">该服务由腾讯应用宝提供技术支持</div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    name: "download",
    data() {
        return {
            url: '',
            deviceType: 1,
            isIos: false,
            isNeedFresh: true,

        }
    },
    mounted() {
        this.getVersion();
        window.addEventListener('resize', this.getVersion);
    },
    methods: {
        async getVersion() {
            // 保证同一类型设备只加载一次接口
            if (this.isIos !== this.isIOSDevice()) {
                this.isNeedFresh = true;
            }
            else {
                this.isNeedFresh = false;
            }
            this.isIos = this.isIOSDevice();
            if (!this.isNeedFresh) return;
            try {
                // const res = await getVersionReq({ deviceType: this.isIos ? 2 : 1 });
                // this.versionInfo = res;
                this.isNeedFresh = false;
            }
            catch (error) {
                console.error(error);
            }
        },
        isIOSDevice() {
            const userAgent = navigator.userAgent || navigator.vendor;
            return /iPad|iPhone|iPod/.test(userAgent);
        }
    },
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    max-width: 490px;
    margin: 0 auto;
    padding: 1rem;
    height: 100vh;
    overflow: auto;
    box-sizing: border-box;

    .content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        box-sizing: border-box;
        padding: 2rem 0;
        height: 100%;
    }

    .ios-content {
        padding: 1rem 0;

        .divider {
            margin: 18px 0;
            width: 100%;
            height: 1px;
            background: #ccc;
        }

        .title {
            font-size: 1.2rem;
            font-weight: bold;
            margin: 12px 0;
        }

        .introduce {
            font-size: 1rem;
            color: #333;

            .content-title {
                font-size: 1rem;
                margin-bottom: 10px;
            }
        }

        .comment-content {
            display: flex;
            gap: 30px;
            align-items: center;

            .comment-left {
                .score {
                    font-size: 2.5rem;
                    font-weight: bold;
                    color: #333;
                }

                .score-desc {
                    font-size: 0.9rem;
                    color: #555;
                    text-align: center;
                    margin-top: 12px;
                    letter-spacing: 1px;
                }
            }

            .comment-item {
                display: flex;
                gap: 6px;
                align-items: center;

                .comment-item-left {
                    width: 100px;
                    text-align: right;

                    img {
                        width: 12px;
                    }
                }

                .comment-item-right {
                    flex: 1;
                    position: relative;
                    height: 3px;
                    border-radius: 4px;
                    background: #CCC;

                    .progress {
                        position: absolute;
                        left: 0;
                        top: 0;
                        background: #000;
                        z-index: 10;
                        height: 100%;
                    }
                }
            }

            .store-item {
                font-size: 0.8rem;
                text-align: right;
                color: #999;
            }

            .comment-right {
                flex: 1;
            }
        }

        .comment-wordWrapper {
            margin-top: 1rem;
            padding: 1rem 0.5rem;
            border-radius: 12px;
            background: #f5f5f5;

            .comment-w-title {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .mb {
                    margin-bottom: 8px;
                }

                .cwt-left {
                    font-weight: bold;

                    img {
                        width: 18px;
                        margin-right: 3px;
                    }
                }

                .cwt-right {
                    font-size: 1rem;
                    text-align: right;
                    color: #999;
                }
            }

            .comment-word {
                margin-top: 1rem;
                color: #333;
                line-height: 1.4;
            }
        }

        .info-list {
            display: flex;
            justify-content: space-between;
            padding-bottom: 12px;
            border-bottom: 1px solid #ccc;
            margin-bottom: 12px;

            .info-left {
                color: #666;
            }

            .info-right {
                font-weight: 600;
            }
        }

        .sheMing {
            .sheMing-title {
                font-size: 1.1rem;
                font-weight: 600;
                margin: 12px 0;
            }

            .sheMing-content {
                font-size: 0.9rem;
                color: #666;
                padding-bottom: 2rem;
            }
        }

        .top {
            display: flex;
            gap: 18px;
            align-items: center;

            .logo {
                width: 110px;
                height: 110px;
                border-radius: 12px;
            }

            .title-wrapper {
                .title {
                    font-size: 1.3rem;
                    font-weight: bold;
                    letter-spacing: 1px;
                }

                .download-desc {
                    font-size: 0.85rem;
                    color: #666;
                    margin: 6px 0 8px 0;
                }
            }

            .btn-group {
                display: flex;
                gap: 12px;

                .btn {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    background: #2b80f2;
                    border-radius: 8px;
                    height: 32px;
                    color: #fff;
                    font-size: .9rem;
                    font-weight: bold;

                    img {
                        width: 18px;
                    }
                }

                .btn-primary {
                    color: #2b80f2;
                    background: #fff;
                    border: 1px solid #2b80f2;
                }
            }
        }

        .app-desc {
            display: flex;
            align-items: center;
            justify-content: space-around;

            .app-desc-item {
                text-align: center;

                .label {
                    color: #999;
                    font-size: 0.9rem;
                }

                .amount {
                    font-size: 1.3rem;
                    font-weight: bold;
                    color: #666;
                    padding: 0.9rem 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .bottom {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #999;
                    font-size: 0.9rem;

                    img {
                        width: 14px;
                    }
                }
            }

            .border {
                width: 1px;
                height: 50px;
                background: #eee;
            }
        }
    }

    .android-content {
        .top {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 40%;

            .logo-wrapper {
                position: relative;
                border-radius: 12px;
                width: 100px;
                height: 100px;

                .logo {
                    width: 100%;
                    height: 100%;
                    border-radius: 12px;
                }

                .logo-text {
                    position: absolute;
                    top: 0;
                    right: 0;
                    background: #2b80f2;
                    color: #fff;
                    font-size: 0.8rem;
                    transform: translate(50%, -50%);
                    padding: 2px;
                    border-radius: 4px;
                }
            }

            .title {
                font-size: 1.8rem;
                font-weight: bold;
                letter-spacing: 3px;
                margin: 12px 0;
            }

            .download-desc {
                font-size: 0.85rem;
                color: #666;
            }

            .download-btn {
                width: 280px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #2b80f2;
                height: 2.6rem;
                border-radius: 8px;
                color: #fff;
                margin: 12px 0 6px 0;
                font-weight: bold;
                font-size: 1.1rem;
                text-decoration: none;
            }

            .yyb-desc {
                font-size: 0.8rem;
                color: #2b80f2;
            }

            .yyb-safe {
                display: flex;
                gap: 12px;
                justify-content: center;
                margin-top: 12px;

                .yyb-item {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    font-size: 0.9rem;
                    color: #666;
                }

                img {
                    width: 18px;
                    object-fit: contain;
                }
            }
        }

        .bottom {
            text-align: center;

            .label {
                font-size: 1rem;
                color: #666;
                margin: 5px 0;
                margin-top: 12px;
            }

            .primary {
                color: #2b80f2;
                margin: 15px 0;
                font-size: 1.15rem;
            }

            .yingyb {
                width: 120px;
            }

            .desc {
                font-size: 0.8rem;
                color: #777;
                margin-top: 4px;         }
        }
    }
}
</style>